import './App.css';
import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import Background from './components/background/Background';
import About from './components/about/About';
import Timeline from './components/timeline/Timeline';
import Projects from './components/projects/Projects';
import Footer from './components/footer/Footer';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import resume from './assets/VincentCai_Resume.pdf'

function Redirect({url}) {
  window.location.replace(url)
}

function App() {
  console.log(process.env)
  return (
    <BrowserRouter>
      <Routes>
        <Route path={process.env.PUBLIC_URL} element={
          <div className="App">
            <Navbar/>
            <Background/>
            <div>
              <div className="content">
                <Home/>
                <About/>
                <Timeline/>
                <Projects/>
              </div>
            <Footer/>
            </div>
          </div>
      }/>
      <Route path={`${process.env.PUBLIC_URL}/resume`} element={<Redirect url={resume}/>}/>
      <Route path={`${process.env.PUBLIC_URL}/zoom`} element={<Redirect url="https://upenn.zoom.us/j/3768258947"/>}/>
      <Route path="*" element={<Navigate to={process.env.PUBLIC_URL} />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
